import { Link, Stack } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink } from "react-router-dom";

interface SsoErrorActionsProps {
	readonly troubleshootUrl: { pathname: string; hash: string } | null;
}

export const SsoErrorActions = ({ troubleshootUrl }: SsoErrorActionsProps) => (
	<Stack spacing={2}>
		{troubleshootUrl && (
			<Link
				component={RouterLink}
				to={troubleshootUrl}
				sx={{ color: "white" }}
				data-testid="login-sso-error__link__troubleshoot"
			>
				<FormattedMessage id="login-sso-error.advanced" defaultMessage="Advanced SSO Troubleshooting" />
			</Link>
		)}
		<Link component={RouterLink} to="/login" sx={{ color: "white" }} data-testid="login-sso-error__link__back">
			<FormattedMessage id="login-sso-error.back" defaultMessage="Back to login" />
		</Link>
	</Stack>
);
